import { SxProps, Theme } from '@mui/material';
import { palette } from 'theme';

const baseStyles = {
  leftColumnCardContent: {
  } as SxProps<Theme>,
  upperRow: {
    borderBottom: `1px solid ${palette.grey[200]}`,
  } as SxProps<Theme>,
  rightColumnArrowPlaceHolder: {
  } as SxProps<Theme>,
  rightColumnContent: {
    marginLeft: '5px',
  } as SxProps<Theme>,
  rightColumnContentUpperRow: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    color: palette.text.primary,
  } as SxProps<Theme>,
  rightColumnContentBottomRow: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '14px',
    color: palette.text.secondary,
  } as SxProps<Theme>,
};

export const dtgStyles = {
  leftColumn: {
  } as SxProps<Theme>,
  leftColumnCardContent: baseStyles.leftColumnCardContent,
  upperRow: baseStyles.upperRow,
  rightColumn: {
    minWidth: '140px',
    padding: '2%',
    backgroundColor: palette.grey[100],
    borderRadius: '8px',
  } as SxProps<Theme>,
  rightColumnUpperRow: {
    borderBottom: `1px solid ${palette.grey[300]}`,
  } as SxProps<Theme>,
  rightColumnBottomRow: {
    paddingTop: '5px',
  } as SxProps<Theme>,
  rightColumnArrowPlaceHolder: baseStyles.rightColumnArrowPlaceHolder,
  rightColumnContent: {
    marginLeft: '5px',
  } as SxProps<Theme>,
  rightColumnContentUpperRow: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    color: palette.text.primary,
  } as SxProps<Theme>,
  rightColumnContentBottomRow: baseStyles.rightColumnContentBottomRow,
};

export const apolloStyles = {
  leftColumn: {
  } as SxProps<Theme>,
  leftColumnCardContent: baseStyles.leftColumnCardContent,
  upperRow: baseStyles.upperRow,
  rightColumn: {
    minWidth: '140px',
    padding: '2%',
    backgroundColor: palette.grey[100],
    borderRadius: '8px',
    marginLeft: '20px',
  } as SxProps<Theme>,
  rightColumnUpperRow: {
  } as SxProps<Theme>,
  rightColumnArrowPlaceHolder: baseStyles.rightColumnArrowPlaceHolder,
  rightColumnContent: {
    marginLeft: '5px',
  } as SxProps<Theme>,
  rightColumnContentUpperRow: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    color: palette.text.primary,
  } as SxProps<Theme>,
  rightColumnContentBottomRow: baseStyles.rightColumnContentBottomRow,
};

export const dtfStyles = {
  leftColumn: {
  } as SxProps<Theme>,
  leftColumnCardContent: baseStyles.leftColumnCardContent,
  upperRow: baseStyles.upperRow,
};
